module.exports = __webpack_public_path__ + "img/icon-window.26a67ad3.svg";